import * as z from 'zod';

import { customErrorMap, ERRORS } from './Error.uiCopy';

z.setErrorMap(customErrorMap);

export const SelectOptionSchema = z.object(
  {
    value: z.string().trim(),
    label: z.string().trim(),
  },
  {
    required_error: ERRORS.required,
  },
);

// This had to be introduced as transform produces ZodEffects which does not play well with .merge and .extend.
// It can be done with .and but in our use case it produces "Intersection results could not be merged" error
// so this is a workaround Zod limitation
// This should be fixed in v4
export const SelectOptionSchemaTransformed = SelectOptionSchema.transform(
  option => option.value,
);

export type SelectOption = z.input<typeof SelectOptionSchema>;

export const BubbleSchema = z.object({
  text: z
    .string({
      required_error: ERRORS.required,
    })
    .min(1, ERRORS.required)
    .max(100, ERRORS.max(100))
    .trim(),
  selected: z
    .boolean({
      required_error: ERRORS.required,
    })
    .optional(),
});

export type Bubble = z.infer<typeof BubbleSchema>;

export const EditOptionSchema = z.literal('edit');
export const CreateOptionSchema = z.literal('create');

export type TypeOptions =
  | z.infer<typeof CreateOptionSchema>
  | z.infer<typeof EditOptionSchema>;

export const IdSchema = z.object({
  id: z.string(),
});
